import { render, staticRenderFns } from "./inspectionResults.vue?vue&type=template&id=2453a4e8&scoped=true"
import script from "./inspectionResults.vue?vue&type=script&lang=js"
export * from "./inspectionResults.vue?vue&type=script&lang=js"
import style0 from "./inspectionResults.vue?vue&type=style&index=0&id=2453a4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2453a4e8",
  null
  
)

export default component.exports